import type { PacketSourceResolved } from "../../lib/api";
import { MessageSquare } from "lucide-react";

/** Q42: chat-style message renderer (Teams / WhatsApp / SMS).
 *
 *  These connectors don't expose a single-message-by-id fetch
 *  with rich formatting, so we render the captured packet text in
 *  a message-bubble layout with channel + participant metadata
 *  from meta_json. */

export function MessageView({ resolved }: { resolved: PacketSourceResolved }) {
  const { header, body } = resolved.render;
  const channel = header.channelName ?? null;
  return (
    <div className="px-4 sm:px-6 py-4 space-y-4">
      <section className="space-y-1">
        <div className="text-xs text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
          <MessageSquare className="w-3.5 h-3.5" />
          {channel ? `In ${channel}` : "Direct message"}
          {header.when && (
            <span className="ml-1 text-slate-400">
              · {new Date(header.when).toLocaleString()}
            </span>
          )}
        </div>
        {header.from && (
          <h2 className="text-sm font-semibold text-slate-800 dark:text-slate-100">
            {header.from}
          </h2>
        )}
      </section>

      {body.text ? (
        <article className="rounded-2xl bg-slate-100 dark:bg-slate-800/60 px-4 py-3 text-sm text-slate-800 dark:text-slate-100 whitespace-pre-wrap leading-relaxed">
          {body.text}
        </article>
      ) : (
        <p className="text-sm text-slate-500 italic">
          (No message body captured.)
        </p>
      )}

      {header.participants && header.participants.length > 0 && (
        <section className="text-xs text-slate-500 dark:text-slate-400">
          <span className="font-semibold mr-1">Participants:</span>
          {header.participants.slice(0, 12).join(", ")}
          {header.participants.length > 12 ? ` +${header.participants.length - 12}` : ""}
        </section>
      )}
    </div>
  );
}
